export { default as DonutChart } from 'components/monitoring/widgets/DonutChart.vue'
export { default as BarChart } from 'components/monitoring/widgets/BarChart.vue'
export { default as AreaChart } from 'components/monitoring/widgets/AreaChart.vue'
export { default as SingleValue } from 'components/monitoring/widgets/SingleValue.vue'
export { default as SimpleTableList } from 'components/monitoring/widgets/SimpleTableList.vue'
export { default as TableList } from 'components/monitoring/widgets/TableList.vue'
